import _find from "lodash/find";
import { useStaticQuery } from 'gatsby';
export const useContact = () => {
  const data = useStaticQuery(query).directusCompany;
  const address = data.addresses[0];
  const email = _find(data.emails, email => email.primary);
  const phoneNumber = _find(data.numbers, number => (number.type === 'phone' || number.type === 'mobile') && number.primary);
  const faxNumber = _find(data.numbers, number => number.type === 'fax' && number.primary);
  return {
    company_name: data.company_name,
    display_name: data.display_name,
    executives: data.executives,
    address,
    email,
    phoneNumber,
    faxNumber,
    legal_form: data.legal_form
  };
};
const query = "1951073086";